import { InputNumber } from 'antd';
import { useEffect, useState } from 'react'

NumberInput = ({
  initialValue,
  save,
  inputValidator=({ target: { value } }) ->
    if !isNaN(value)
      value
  props...
}) ->

  [loading, setLoading] = useState(false)
  [value, setValue] = useState(initialValue)

  useEffect(->
    setValue(initialValue)
  , [initialValue])

  <InputNumber
    value={value}
    disabled={loading}
    {props...}
  />

export default NumberInput
